// Utility function to format constraint values for display
export const formatConstraintValue = (value: string): string => {
  return value
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

// Map constraint types to their corresponding database field names
export const constraintTypeToFieldMap: Record<string, string> = {
  'Gender': 'genders',
  'Pathology': 'pathologies', 
  'Sport': 'programSports',
  'Special program': 'specialPrograms',
  'Week focus': 'weekFocus',
  'User level': 'userLevel',
  'Category': 'categories',
  'Material': 'materials'
};

// Map database field names to display names
export const fieldToDisplayNameMap: Record<string, string> = {
  'genders': 'Gender',
  'gender': 'Gender',
  'pathologies': 'Pathology',
  'pathology': 'Pathology',
  'programSports': 'Sport', 
  'sport': 'Sport',
  'specialPrograms': 'Special program',
  'specialProgram': 'Special program',
  'weekFocus': 'Week focus',
  'userLevels': 'User level',
  'userLevel': 'User level',
  'categories': 'Category',
  'category': 'Category',
  'materials': 'Material',
  'material': 'Material'
};

// Utility function to convert constraints object from API format to array format for form usage
export function constraintsObjectToArray(constraintsObj: any): { type: string, values: string[] }[] {
  if (!constraintsObj || typeof constraintsObj !== 'object') return [];
  
  return Object.entries(constraintsObj)
    .filter(([_, values]) => Array.isArray(values) && values.length > 0)
    .map(([field, values]) => ({
      type: fieldToDisplayNameMap[field] || field,
      values: values as string[]
    }));
} 